import { SupabaseClient } from '@supabase/supabase-js';
import { revalidateBuyerDashboard } from '~/app/actions/revalidateBuyerDashboard';

export const deleteSearch = async (
  supabase: SupabaseClient,
  searchId: number
) => {
  // SUPABASE: Convert to server action
  const { error } = await supabase.from('searches').delete().eq('id', searchId);
  if (error) {
    console.error(error);
  } else {
    revalidateBuyerDashboard();
  }
  return { error };
};
